/**
 * Flow A (차트 드래그로 신규 TP/SL 추가)의 핵심 도메인 로직.
 *
 * 차트에서 포지션 라인의 핸들을 드래그해 놓은 가격(`draggedPrice`)으로부터,
 * 확인 모달에 넘길 "의도(intent)"를 계산한다. 차트/DOM에 의존하지 않는 순수 함수라
 * WEB·APP 양쪽에서 공통으로 재사용한다.
 */

export type TpSlDragPosition = {
  positionId: string;
  side: 'Long' | 'Short';
  entryPrice: number;
  /** 절대 포지션 수량. */
  quantity: number;
};

export type TpSlDragIntent = {
  positionId: string;
  side: 'Long' | 'Short';
  /** 진입가 대비 드래그 방향으로 결정. 이익이면 TP, 손실이면 SL. */
  kind: 'TP' | 'SL';
  /**
   * 드래그 출처 구분. 기존 TP/SL order line을 끌어 모달을 연 경우(수정)엔 그 주문 id가 실린다.
   * 포지션 라인을 끌어 새로 만드는 경우(생성)엔 undefined. 모달은 이 값으로 수정/생성 모드를 가른다.
   */
  orderId?: string;
  /** 모달에 prefill할 트리거 가격. */
  triggerPrice: number;
  /** 부호 있는 예상 손익. TP면 양수, SL이면 음수. */
  expectedPnl: number;
  /** 진입가 대비 가격 변화율(%). 부호 그대로, side 무관. 모달의 "X% from entry" 표기용. */
  pricePercentFromEntry: number;
};

export function deriveTpSlDragIntent(position: TpSlDragPosition, draggedPrice: number): TpSlDragIntent {
  const direction = position.side === 'Long' ? 1 : -1;
  const expectedPnl = (draggedPrice - position.entryPrice) * direction * position.quantity;
  const pricePercentFromEntry =
    position.entryPrice === 0 ? 0 : ((draggedPrice - position.entryPrice) / position.entryPrice) * 100;

  return {
    positionId: position.positionId,
    side: position.side,
    kind: expectedPnl >= 0 ? 'TP' : 'SL',
    triggerPrice: draggedPrice,
    expectedPnl,
    pricePercentFromEntry,
  };
}
